export default __webpack_public_path__ + "static/media/Nick-Peri-Pattie-testimonial.fe644948.webp";